












































import i18n from '@/i18n';
import { ProfileResponse } from '@/model/Profile';
import { Field } from '@/model/table/Field';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';

@Component({
    components: {
        ConfirmationModal,
    },
})
export default class EventEditorsTable extends Vue {
    @Prop(String) readonly eventRole!: string;

    @Prop() readonly invitedUsers!: ProfileResponse[];

    get getTableFields(): Field[] {
        const fields = [
            {
                key: 'firstName',
                label: i18n.t('event-editors.table.first-name').toString(),
            },
            {
                key: 'lastName',
                label: i18n.t('event-editors.table.last-name').toString(),
            },
            {
                key: 'email',
                label: i18n.t('event-editors.table.email').toString(),
            },
        ];
        if (this.eventRole === 'ADMINISTRATOR') {
            fields.push({
                key: 'actions',
                label: i18n.t('event-editors.table.button').toString(),
            });
        }
        return fields;
    }

    @Emit('onRemove')
    onRemove(profileResponse: ProfileResponse): ProfileResponse {
        this.$bvModal.hide(`remove-modal${profileResponse.id}`);

        return profileResponse;
    }
}
